"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotOverlappingWithFillMinutesError = exports.PeriodJoiner = void 0;
const date_fns_1 = require("date-fns");
const _1 = require(".");
const period_1 = require("./period");
const sortBy_1 = require("./sortBy");
class PeriodJoiner {
    /**
     * Periodの配列をJoinする
     * @param periods
     * @param fillLessThanMinutes 間隔がこの時間以下であれば詰める
     */
    static joinPeriods(periods, fillLessThanMinutes = 0) {
        if (periods.isEmpty()) {
            return new _1.Periods([]);
        }
        const periodsStartTimeDesc = (0, sortBy_1.sortBy)(periods.periods, (p) => p.start, 'asc');
        // 1つ目のPeriodをセット
        const result = [periodsStartTimeDesc.shift()];
        periodsStartTimeDesc.forEach((period) => {
            const lastPeriod = result[result.length - 1];
            if (this.arePeriodsPartiallyOverlapping(lastPeriod, period, fillLessThanMinutes)) {
                result[result.length - 1] = this.joinPeriod(lastPeriod, period, fillLessThanMinutes);
            }
            else {
                result.push(period);
            }
        });
        return new _1.Periods(result);
    }
    /**
     * 2つのTimePeriodをJoinする。
     * 時間の間隔がfillLessThanMinutes以下であれば詰める。
     * @param li Left Period
     * @param ri Right Period
     * @param fillLessThanMinutes LeftとRightの間隔がこの時間以下であれば詰める
     * @throws NotOverlappingWithFillMinutesError fillMinutes以上に間隔が離れている場合
     */
    static joinPeriod(li, ri, fillLessThanMinutes = 0) {
        if (!this.arePeriodsPartiallyOverlapping(li, ri, fillLessThanMinutes)) {
            throw new NotOverlappingWithFillMinutesError();
        }
        const start = (0, date_fns_1.isBefore)(li.start, ri.start) ? li.start : ri.start;
        const end = (0, date_fns_1.isAfter)(li.end, ri.end) ? li.end : ri.end;
        return new period_1.Period(start, end);
    }
    /**
     * 2つのTimePeriodが被っているかを判定する。
     * @param li Left Period
     * @param ri Right Period
     * @param allowMerginMinutes この時間間隔分は許容する
     */
    static arePeriodsPartiallyOverlapping(li, ri, allowMerginMinutes) {
        const liEndPlusMergin = (0, date_fns_1.addMinutes)(li.end, allowMerginMinutes);
        const liStartMinusMergin = (0, date_fns_1.subMinutes)(li.start, allowMerginMinutes);
        return !(liEndPlusMergin <= ri.start || ri.end <= liStartMinusMergin);
    }
}
exports.PeriodJoiner = PeriodJoiner;
class NotOverlappingWithFillMinutesError extends Error {
}
exports.NotOverlappingWithFillMinutesError = NotOverlappingWithFillMinutesError;
//# sourceMappingURL=periodJoiner.js.map